import restaurantInstance from '../../instance'

const swapTableMove = (tableId, data) => {
  return restaurantInstance.put(`/tables/${tableId}/orders/move`, data)
}

export default swapTableMove
